import styled from 'styled-components';
export const VenturesContainer = styled.div`
  .ventures-main {
    padding-top: 0px !important;
  }
  .ventures-thumb {
    margin-top: -94px;

    @media only screen and (max-width: 990px) {
      margin-top: -93px;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 40px;
    }
  }
  .dots {
    position: absolute;
    margin-left: 30px;
    @media only screen and (max-width: 767px) {
      position: relative;
    }
  }
  .approach-container {
    margin-left: 108px;
    @media only screen and (max-width: 767px) {
      margin-left: 30px;
    }
  }
  .ventures-head {
    margin-top: 94px;
  }
  .ventures-single-step {
    margin-top: 87px;
  }
  .ventures-step {
    margin-top: 180px;
  }
  .ventures-vision {
    margin-top: 87px;
  }
  .ventures-invest {
    text-align: center;
    padding: 79px;
    @media only screen and (max-width: 767px) {
      padding: 40px;
    }
  }
  .ventures-contact-form {
    overflow-x: hidden;
    padding-left: 60px;
    @media only screen and (max-width: 767px) {
      padding-left: 0px;
    }
  }
  .team-section {
    margin: 125px 113px 0 108px;
    @media only screen and (max-width: 767px) {
      margin: 65px 65px 0 65px;
      .team-2 {
        margin-top: 50px;
      }
    }
  }
  .rectangle {
    width: 428px;
    height: 105px;
    border-radius: 2px;
    text-align: left;
    padding: 34px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.02);
    background-color: #ffffff;
  }

  .ventures-single-step-p {
    margin-top: 30px;
    color: rgba(0, 0, 0, 0.68);
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: -0.13px;
  }
  .ventures-main-p {
    color: #000000;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: -0.13px;
  }
  .venture-about-title {
    margin-top: 48px;
    font-size: 28px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
  }
  .venture-about-desc {
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #000000;
  }
  .ventures-vision::before {
    background-color: #191733;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 47%;
    content: '';
  }
  .ventures-vision {
    padding: 180px 0 90px;
    padding: 180px 0;
    position: relative;
    content: 'Vision';
    right: 0;
  }
  .ventures-lookfor {
    padding: 130px 0 90px 111px;
    position: absolute;
    z-index: 9;
    content: 'Vision';
    background-color: #000000;
    margin-top: 231px;
    right: 0;
    width: 852px;
    height: 868px;
    overflow-x: hidden;
    @media only screen and (max-width: 1335px) {
      margin-top: 141px;
    }
    @media only screen and (max-width: 1265px) {
      position: relative;
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      position: relative;
      padding: 130px 20px 90px 20px;
      height: 1050px;
      width: 100%;
    }
  }

  .team-desc {
    font-family: 'Be Vietnam Pro';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.72;
    letter-spacing: -0.13px;
    color: #000000;
    padding-right: 75px;
  }
  .team-name {
    font-family: 'Be Vietnam Pro';
    font-size: 19px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.89;
    letter-spacing: 0.16px;
    color: #000000;
    margin-top: 18px;
  }
  .col-md-4 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .contact-container {
    padding: 111px 0 0 134px;
    color: #ffffff;
    @media only screen and (max-width: 767px) {
      padding: 111px 0 0 90px;
      .contact-text {
        padding-left: 0px;
      }
    }
  }

  .contact-container h1 {
    color: #fff;
  }
  .contact-desc {
    color: #ffffff;
    font-family: 'Be Vietnam Pro';
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.15px;
    line-height: 38px;
  }
  .contact-email {
    color: #000000;
    font-family: 'Be Vietnam Pro';
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.15px;
    line-height: 24px;
  }
  .ventures-lookfor-title {
    font-family: Vollkorn;
    font-size: 48px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: -0.36px;
    color: #ffffff;
  }

  .horizontal-line {
    border: 11px solid #222130;
    margin-top: 54px;
  }

  .ventures-approach::before {
    // background-color: #191733;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 47%;
    content: '';
  }
  .ventures-approach {
    padding: 180px 0 90px;
    padding: 180px 0;
    position: relative;
    content: 'Vision';
    right: 0;
  }
  .vision-bg {
    font-size: 158px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.5;
    letter-spacing: 3px;
    color: rgba(57, 53, 53, 0.05);
    right: 0;
    top: 0;
  }
  .vision-bg-title {
    color: #ffffff;
    letter-spacing: 4px;
  }
  .dash {
    display: inline-block;
    height: ${({ horizontal }) => (horizontal ? '22px' : '1px')};
    width: ${({ horizontal }) => (horizontal ? '1px' : '22px')};
    background-color: ${({ theme: { colors }, dark }) =>
      dark ? colors.black : colors.white};
    bottom: 0px;
    vertical-align: middle;
    left: 5px;

    ${({ horizontal }) =>
      horizontal &&
      `
      margin-left: 43px;
      transform: translateY(-3px);
    `}
  }

  ul {
    padding: 40px 234px 0 25px;
  }
  li {
    margin-top: 30px;
    color: #fff;
    font-size: 25px;
  }
  .lookfor-item {
    font-family: 'Be Vietnam Pro';
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    color: #ffffff;
  }
  .tick-mark {
    margin-top: 10px;
    color: #ff4552;
  }
  .approach-list-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.55;
    letter-spacing: -0.15px;
    color: #000000;
  }
  .invest-step {
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.22px;
    color: #0a090b;
    position: absolute;
    margin-left: 35px;
    font-family: Vollkorn;
  }
  .button {
    border-radius: 2px;
    background-color: ${({ theme: { colors } }) => colors.pink};
    min-width: 160px;
    padding: 6px 0;
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 16px;
    letter-spacing: 0.18px;
    line-height: 28px;

    &:hover {
      color: ${({ theme: { colors } }) => colors.white};
      background-color: ${({ theme: { colors } }) => colors.pinkHover};
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 10px;
      border-radius: 0;
    }
  }

  @media (max-width: 767px) {
    .ventures-vision {
      padding: 50px 0 90px;
    }

    .ventures-vision::before {
      top: 0;
      width: 100%;
      height: 60%;
    }
    .abt-second-desc {
      padding-top: 35px;
    }
    .ventures-approach {
      padding: 50px 0 90px;
    }

    .ventures-approach::before {
      top: 0;
      width: 49%;
      height: 60%;
    }
    .rectangle {
      width: 100%;
      height: 100px;
      text-align: left;
      padding: 25px 30px;
      border-radius: 2px;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.02);
      background-color: #ffffff;
    }
    .invest-second-step {
      margin-top: 50px;
    }
    .invest-step {
      font-size: 28px !important;
      margin-left: 12px !important;
    }
  }
`;
